import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Employees extends CommonCRUD {}

export default Employees;
